import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { usePageTitle } from '../../contexts/PageTitleContext';
import './PageHeader.scss';

/**
 * PageHeader Component - Page title with optional icon and actions
 * Matches UX_DESIGNS styling with theme support
 * 
 * Props:
 *   backButton — boolean, renders an inline back arrow before the icon/title
 */
const PageHeader = ({ 
  title, 
  description, 
  icon: Icon, 
  actions, 
  backButton = false,
  onBack,
  className = '' 
}) => {
  const navigate = useNavigate();
  const { setPageTitle } = usePageTitle();
  const handleBack = onBack || (() => navigate(-1));

  useEffect(() => {
    setPageTitle(title || '');
    return () => setPageTitle('');
  }, [title, setPageTitle]);

  return (
    <div className={`page-header ${className}`}>
      <div className="page-header__left">
        {backButton && (
          <button
            type="button"
            className="page-header__back-btn"
            onClick={handleBack}
            aria-label="Go back"
          >
            <ArrowLeft size={18} />
          </button>
        )}
        {Icon && (
          <div className="page-header__icon">
            <Icon size={20} />
          </div>
        )}
        <div className="page-header__text">
          <h1 className="page-header__title">{title}</h1>
          {description && (
            <p className="page-header__description">{description}</p>
          )}
        </div>
      </div>
      {actions && (
        <div className="page-header__actions">
          {actions}
        </div>
      )}
    </div>
  );
};

export default PageHeader;
